<template>
    <div>
        <el-card>
        <template v-slot:header>
            <div class="clearfix">
            <span style="font-weight: bold;"><i class="el-icon-s-data" style="font-weight: bold;font-size: larger;margin-right: 5px;"></i>Enhancers Number</span>
            </div>
        </template>
        <div class="container">
            <el-container>
            <el-main>
                <div id="barChart" style="width:100%;height:500px;"></div>
            </el-main>
            </el-container>
        </div>
        </el-card>
    </div>
    </template>
    
    <script>
    export default {
        data() {
            return {
                url: "http://183.175.59.4/devenhancer/",
            };
        },
        props: {
            species: {
                type: String,
                required: true
            },
            tissue: {
                type: [String, Array],
                required: true
            },
        },
        mounted() {
            this.$nextTick(this.handleAnalysis);
        },
        methods: {
            async fetchData(endpoint) {
                try {
                    const params = {
                        Species: this.species,
                        Tissue: this.tissue
                    };
                    const response = await this.$axios.get(this.url + endpoint, { params });
                    const data = response.data;
                    if (Array.isArray(data) && data.length > 0) {
                        const count = {};
                        for (const item of data) {
                            const tissue = item.Tissue.trim();
                            count[tissue] ? count[tissue]++ : (count[tissue] = 1);
                        }
                        // Ensure the order of tissues in xAxis is consistent with the order in this.tissue
                        return this.tissue.map(name => ({ name, value: count[name] || 0 }));
                    } else {
                        this.$message.warning('loading data');
                        return [];
                    }
                } catch (error) {
                    console.error(error);
                    this.$message.error('Failed to get data');
                    return [];
                }
            },
            async handleAnalysis() {
    const [seriesData1, seriesData2, seriesData3] = await Promise.all([
        this.fetchData("individual"),
        this.fetchData("selist"),
        this.fetchData("telist")
    ]);

    const chart = this.$echarts.init(document.getElementById('barChart'));
    chart.setOption({
        title: {
            left: 'center'
        },
        tooltip: {
            trigger: "axis",
            axisPointer: {
                type: "shadow",
            },
        },
        legend: {
            data: ['Typical-enhancer', 'Super-enhancer', 'Core-enhancer'], // Corrected legend names
            top: 'top'
        },
        grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true,
        },
        xAxis: {
            type: "category",
            data: this.tissue,
        },
        yAxis: {
            type: "value",
            boundaryGap: [0, 0.01],
            name: "number",
            nameTextStyle: {
                fontSize: 14,
            },
        },
        series: [
            {
                name: "Core-enhancer",
                type: "bar",
                data: seriesData1,
                itemStyle: {
                    color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: '#4AA9E9'
                    }, {
                        offset: 1,
                        color: '#006687'
                    }])
                },
                label: {
                    show: true,
                    position: 'top',
                    color: '#333'
                },
                barWidth: 40, // 设置柱子宽度
            },
            {
                name: "Super-enhancer",
                type: "bar",
                data: seriesData2,
                itemStyle: {
                    color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: '#ECC042'
                    }, {
                        offset: 1,
                        color: '#7F6E00'
                    }])
                },
                label: {
                    show: true,
                    position: 'top',
                    color: '#333'
                },
                barWidth: 40, // 设置柱子宽度
            },
            {
                name: "Typical-enhancer",
                type: "bar",
                data: seriesData3,
                itemStyle: {
                    color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: '#52C19F'
                    }, {
                        offset: 1,
                        color: '#005F83'
                    }])
                },
                label: {
                    show: true,
                    position: 'top',
                    color: '#333'
                },
                barWidth: 40, // 设置柱子宽度
            },
        ],
    });
},
        }
    }
    </script>


// WEBPACK FOOTER //
// src/components/comparison/Vsnumber.vue